/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Menu, Button, MenuProps, Input, Modal, Tabs, Select, message, notification, Row, Col, Form, Spin } from 'antd';
import { useAppContext } from "../../../context/appContext";
import { CloseOutlined } from '@ant-design/icons';
const { TextArea } = Input;
const LoginModal = ({ displayLogin, setDisplayLogin, onLogin }) => {

    const [login, setLogin] = useState({
        email: null,
        password: null
    })

    const goBack = () => {
        setDisplayLogin(false)
    }

    return (
        <Modal
            maskClosable={false}
            closeIcon={<CloseOutlined style={{ color: "white" }} />}
            bodyStyle={{
                backgroundColor: 'black',
                border: "1px solid grey"
            }}
            visible={displayLogin} footer={null} onCancel={() => { setDisplayLogin(false); }}>
            <div style={{ fontWeight: "600", color: "white" }}>
                <svg style={{ position: "relative", top: 3 }} xmlns="http://www.w3.org/2000/svg" width="25.179" height="15.788" viewBox="0 0 39.179 20.788">
                    <path id="Path_5997" data-name="Path 5997" d="M221.646,213.5a4.129,4.129,0,1,0,4.128,4.128A4.132,4.132,0,0,0,221.646,213.5Zm0,5.857a1.729,1.729,0,1,1,1.729-1.729A1.732,1.732,0,0,1,221.646,219.355ZM247.9,211.83H231.867a10.393,10.393,0,1,0,0,11.595h4.71a1.2,1.2,0,0,0,.849-.351l1.615-1.616,1.615,1.616a1.2,1.2,0,0,0,.849.351h.968a1.2,1.2,0,0,0,.849-.351l1.615-1.616,1.615,1.616a1.2,1.2,0,0,0,.849.351h.968a1.2,1.2,0,0,0,.849-.351l2.462-2.463a1.2,1.2,0,0,0,.351-.849v-3.8a4.137,4.137,0,0,0-4.13-4.13Zm-16.661,5.8a7.656,7.656,0,0,1-.065.967c-.008.07-.021.141-.032.211a7.851,7.851,0,0,1-.158.793c-.015.051-.026.1-.041.156a7.987,7.987,0,1,1,0-4.264c.017.057.03.115.045.173.066.256.116.516.156.777.011.074.025.148.033.223a8.107,8.107,0,0,1,.064.961v0Zm18.389,1.638-1.746,1.747-2.1-2.1a1.236,1.236,0,0,0-1.7,0l-2.1,2.1-2.1-2.1a1.236,1.236,0,0,0-1.7,0l-2.112,2.112h-3.017c.009-.028.016-.057.025-.085.061-.181.116-.365.167-.551.035-.127.068-.253.1-.382.039-.166.075-.331.107-.5s.056-.344.08-.517c.017-.134.038-.267.05-.4.03-.317.048-.635.049-.955v0h0c0-.321-.018-.642-.05-.961-.012-.132-.032-.261-.05-.391-.024-.179-.049-.356-.083-.533s-.065-.323-.1-.483q-.048-.2-.1-.4c-.05-.177-.1-.354-.159-.527-.011-.031-.018-.065-.03-.1H247.9a1.731,1.731,0,0,1,1.729,1.729v3.3Z" transform="translate(-212.85 -207.232)" fill="#fff" />
                </svg>
                <span style={{ marginLeft: 5 }}>Login </span></div>
            <div style={{ color: "white", margin: "30px 0" }}>
                <label>Email</label>
                <Input value={login.email} onChange={(e) => { setLogin({ ...login, email: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Enter Email" />
            </div>

            <div style={{ color: "white", margin: "30px 0" }}>
                <label>Password</label>
                <Input type="password" value={login.password} onChange={(e) => { setLogin({ ...login, password: e.target.value }) }} style={{ marginTop: 10 }} placeholder="Enter Password" />
            </div>

            <div style={{ display: "flex", flexDirection: "row", gap: 15, justifyContent: "space-between" }}>
                <Button onClick={() => { goBack() }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">BACK</Button>
                <Button onClick={() => { onLogin(login) }} style={{ backgroundColor: "#161616", color: "white", flex: 1, height: 50 }} type="default">OK</Button>
            </div>
        </Modal>
    );
};

export default LoginModal;